module.exports = __webpack_public_path__ + "static/img/irole.1dcee9f.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/img/role3/kr/irole.png
// module id = ssWb
// module chunks = 7